import React from 'react';
import PageChrome from '../../components/layout/PageChrome';
import RichText from '../../components/ui/RichText';
import mission from '../../cms/mission.json';
import '../../css/about/Mission.css';

const Mission = () => {
  const values = mission.coreValues || [];

  return (
    <PageChrome
      title={mission.headerTitle}
      subtitle={mission.headerSubtitle}
      intro={mission.missionStatement}
    >
      <div className="mission-container">
        <section className="mission-section">
          <div className="mission-content">
            <div className="values-section">
              <h2 className="values-title">{mission.valuesTitle}</h2>
              <RichText value={mission.valuesSubtitle} className="values-subtitle" />

              <div className="values-grid">
                {values.map((value, index) => (
                  <div key={value.title} className="value-card">
                    <div className="value-icon">{value.icon}</div>
                    <h3 className="value-title">{value.title}</h3>
                    <RichText value={value.description} className="value-description" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageChrome>
  );
};

export default Mission; 